module.exports = __webpack_public_path__ + "static/kereszty_team-93852e5486d48d6d3a2dbace06228fa6.jpg";